module.exports = __webpack_public_path__ + "478b5ee88f4ba146caf08d56f2bfc392.jpg";